module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-desktop-1220x150.8cef44b8.jpg";